import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Profession, ProfessionForm } from '../models';

@Injectable()
export class ProfessionService {

    professionsUrl = environment.dns + 'api/professions/';

    constructor(private http: HttpClient) { }

    getList(): Observable<Profession[]> {
        return this.http.get<Profession[]>(this.professionsUrl + 'list');
    }

    getOne(id: number): Observable<Profession> {
        return this.http.get<Profession>(this.professionsUrl + id);
    }

    add(professionForm: ProfessionForm): Observable<Profession> {
        return this.http.post<Profession>(this.professionsUrl, professionForm);
    }

    update(professionForm: ProfessionForm): Observable<Profession> {
        return this.http.put<Profession>(this.professionsUrl, professionForm);
    }

    delete(id: number): Observable<boolean> {
        return this.http.delete<boolean>(this.professionsUrl + id);
    }
}